import React, { useContext } from 'react';
import ContainerContent from '@firsttable/web-components/molecules/ContainerContent';
import { Row, Col, Title, Text, Box } from '@firsttable/web-components/atoms';
import RowHead from '@firsttable/web-components/molecules/RowHead';
import SilverstripeContext from '../context/Silverstripe';
import SEO from '../SEO';

const SideBarLayout = ({
  title,
  menu,
  children,
  breadcrumbs,
  subTitle,
  hideSideBarOnMobile,
}: {
  title?: string;
  menu: React.ReactNode;
  children: React.ReactNode;
  breadcrumbs?: React.ReactNode;
  subTitle?: string;
  hideSideBarOnMobile?: boolean;
}) => {
  const { page } = useContext(SilverstripeContext);
  const pageTitle = title || page?.title;

  return (
    <>
      {page && (
        <SEO
          id={page.id}
          title={page.metaTitleFormatted}
          description={page.metaDescription}
          ogImage={page.ogImage}
          metaTags={page.metaTags}
          slug={page.slug}
        />
      )}
      <ContainerContent>
        <Row gap={120}>
          <Col
            width={[1, 1, 1 / 3]}
            mb={['40px', '50px', 0]}
            pt={[0, 0, 22]}
            display={hideSideBarOnMobile ? ['none', 'none', 'block'] : null}>
            {menu}
          </Col>
          <Col width={[1, 1, 2 / 3]} line hideLineOnMobile>
            {(page || breadcrumbs || subTitle) && (
              <Box mb={['l', 'xl']}>
                {pageTitle && (
                  <Title as="h1" size="h1" mb="s">
                    {pageTitle}
                  </Title>
                )}
                {breadcrumbs}
                {subTitle && (
                  <Text letterSpacing="-0.5px" fontSize="xl">
                    {subTitle}
                  </Text>
                )}
              </Box>
            )}
            {children}
          </Col>
        </Row>
      </ContainerContent>
    </>
  );
};

SideBarLayout.propTypes = {};

export default SideBarLayout;
